import { Box, Theme, Typography, makeStyles } from '@material-ui/core'
import SpacingBox from '../SpacingBox/SpacingBox'
import AdditionalInfoTooltip from './AdditionalInfoTooltip'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import { useCompanyName } from '@src/utils/useCompanyName'

type PromosProps = {
  promoCode: string
  promoDiscount: number
}

const useStyles = makeStyles((theme: Theme) => ({
  additionInfoTooltip: {
    maxWidth: 314,
  },
  promoDiscount: {
    fontStyle: 'italic',
    fontSize: theme.typography.pxToRem(12),
    fontFamily: 'lato',
    fontWeight: theme.typography.fontWeightRegular,
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(2),
    },
  },
  promoWithCodeText: {
    fontWeight: 900,
  },
  withCodeText: {
    color: theme.palette.error.main,
    fontSize: theme.typography.pxToRem(14),
  },
}))

const Promos = ({ promoCode, promoDiscount }: PromosProps) => {
  const classes = useStyles()
  const companyName = useCompanyName()

  return (
    <SpacingBox mt={1} data-testid="promos-container">
      <Box display="flex">
        <Typography className={classes.withCodeText} component="span">
          <Typography
            className={`${classes.withCodeText} ${classes.promoWithCodeText}`}
            component="span"
          >
            <span>-</span>
            <FormattedNumber
              value={promoDiscount / 100}
              style="percent"
              minimumFractionDigits={0}
            />
          </Typography>{' '}
          <FormattedMessage id="WITH_CODE" defaultMessage="with code" />{' '}
          <Typography className={classes.promoWithCodeText} component="span">
            {promoCode}
          </Typography>
        </Typography>
        <AdditionalInfoTooltip
          customClasses={{ tooltip: classes.additionInfoTooltip }}
          dataTestId="promos-additional-info"
          showAdditionalColumns={false}
          showTitle={false}
          tooltipContent={
            <>
              <Box mb={4}>
                <Typography>
                  <FormattedMessage
                    id="PROMOTION_BEST_PRICE"
                    defaultMessage="The best price will be determined in your cart based on all available options."
                  />
                </Typography>
              </Box>
              <Box>
                <Typography>
                  <FormattedMessage
                    id="PROMOTION_DETAIL_CONDITIONS"
                    defaultMessage="Promotion valid for a limited time, only on certain items, and limited quantities at the discretion of {companyName}. Exclusions may apply. Valid for web orders only."
                    values={{ companyName }}
                  />
                </Typography>
              </Box>
            </>
          }
        />
      </Box>
      <Box className={classes.promoDiscount}>
        <FormattedMessage
          id="WEB_ONLY_DISCOUNT"
          defaultMessage="Web-Only Discount"
        />
      </Box>
    </SpacingBox>
  )
}

export default Promos
